import { render, staticRenderFns } from "./MarketingBoxes.vue?vue&type=template&id=e7209372&"
import script from "./MarketingBoxes.vue?vue&type=script&lang=js&"
export * from "./MarketingBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports